import { useTranslation } from "react-i18next";
import "../styles/CatalogSheet.css";

import CatalogProductGrid from "../components/catalog/CatalogProductGrid";
import CatalogSheetHeader from "../components/catalog/CatalogSheetHeader";

export default function MiniCatalogSheet({
  open,
  title,
  products = [],
  onClose,
  onAction,
}) {
  const { t, i18n } = useTranslation("catalog");

  if (!open) return null;

  function handleProductBlockAction(a) {
    if (a?.type === "open_product") {
      return onAction?.(a);
    }

    if (a?.type === "add_to_cart") {
      return onAction?.(a);
    }

    return onAction?.(a);
  }

  return (
    <div
      className="csOverlay isOpen"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="csSheet"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER як у каталога */}
        <CatalogSheetHeader
          title={title || t("products_title")}
          canGoBack={false}
          onBack={() => {}}
          onClose={onClose}
          t={t}
        />

        {/* CONTENT */}
        <div
          className="csContent"
          style={{
            paddingBottom: `calc(80px + env(safe-area-inset-bottom, 0px))`,
          }}
        >
          {products?.length ? (
            <CatalogProductGrid
              title={title || t("products_title")}
              products={products}
              onAction={handleProductBlockAction}
              perPage={12}
            />
          ) : (
            <div className="csEmpty">
              {t("empty_products")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}